var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0h24v24H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,9l5,5v7h-5v-4M8,21H3v-7l5-5M9,10v-6c0-.6.4-1,1-1h10c.6,0,1,.4,1,1v17h-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,11h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,15h0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingCommunity);
export default __webpack_public_path__ + "static/media/building-community.fc707795276bd1e57f4d624f3b3f0e5e.svg";
export { ForwardRef as ReactComponent };